// import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { Moment } from 'moment';
import { Subscription } from 'rxjs';
import { formatDate, formatDateTime } from '../../functions/shared-functions';
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD MMM YYYY',
  },
  display: {
    dateInput: 'MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD MMM YYYY',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
@Component({
  selector: 'tm-month-year',
  templateUrl: './month-year.component.html',
  styleUrls: ['./month-year.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },


  ],
})
export class MonthYearComponent implements OnInit {

  @Input() placeholder;
  @Input() type;
  @Input() value;
  @Input() id;
  @Input() style;
  @Input() class;
  @Input() label;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() form: UntypedFormGroup;
  @Input() controlName;
  @Input() label_block;
  @Output() getValue = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Input() field;
  @Input() minValue;
  @Input() maxValue;
  @Input() time_to_be_considered;
  @Input() disabled;
  @Input() verified_status;
  @Input() notes;
  @Input() reason;
  @Input() verification_required;
  @Input() label_overflow;
  @Input() consider_time;
  @Input() onlyDateMonth = 0;
  @Input() design_pattern;
  @Input() hide_label;
  @Input() float_label;

  @Input() appearance;
  @ViewChild('picker') picker;

  subscription: Subscription;
  prev_value;
  date = new UntypedFormControl(moment());

  picker_open_flag = 1;
  random_id = 'date_picker' + Math.floor((Math.random() * 10000) + 1) + Date.now();

  constructor() {

  }

  ngOnInit() {
    if (this.onlyDateMonth) {
      MY_FORMATS.display.dateInput = 'DD-MMM'
    }
    // setTimeout(() => {
    //   if (this.form.get(this.controlName).value) {
    //     this.date.setValue(new Date(this.form.get(this.controlName).value));
    //     if (this.time_to_be_considered && this.date.value) {
    //       this.form.get(this.controlName).setValue(moment.parseZone(this.date.value).format('YYYY-MM-DD'));
    //     }
    //   }

    // });
    // this.subscription = this.form.get(this.controlName).valueChanges.subscribe(res => {
    //   if (res && res != this.prev_value) {
    //     this.prev_value = res;
    //     this.date.setValue(new Date(this.form.get(this.controlName).value));
    //     if (this.time_to_be_considered && this.date.value) {
    //       this.form.get(this.controlName).setValue(moment.parseZone(this.date.value).format('YYYY-MM-DD'));
    //     }
    //     this.onChange.emit({ value: moment.parseZone(this.form.get(this.controlName).value).format('YYYY-MM-DD') });
    //   }
    //   if (!res) {
    //     this.prev_value = res;
    //     this.date.reset();
    //   }
    // })
  }
  ngOnChanges(ev) {
    if (ev && ev.minValue) {
      this.minValue = new Date(ev.minValue.currentValue)
    }
    if (ev && ev.value) {
      this.value = ev.value.currentValue;
      if (this.value && this.value != '') {
        this.date.patchValue(this.value);
      }
      else {
        this.date.reset();
      }
    }
  }

  addEvent(ev) {
    if (ev && ev.value) {
      let utc_date
      if (this.consider_time) {
        utc_date = formatDateTime(ev.value)
      }
      else {
        utc_date = formatDate(ev.value)
      }
      this.form.get(this.controlName).setValue(utc_date);

      this.getValue.emit(ev);
      this.onChange.emit({ value: utc_date });
    }

  }

  anc(evt) {
  }

  removeDate(ev) {
    ev.preventDefault();
    this.form.get(this.controlName).reset();
    if (this.consider_time) {
      this.onChange.emit({ value: formatDateTime(this.form.get(this.controlName).value) });
    }
    else {
      this.onChange.emit({ value: formatDate(this.form.get(this.controlName).value) });
    }
    this.date.reset();
  }

  openPicker(open_flag) {
    if (open_flag) {
      this.picker.open();
    }
  }

  chosenYearHandler(normalizedYear: Moment) {

    let ctrlValue;
    if (this.date.value) {
      ctrlValue = moment(this.date.value);
      ctrlValue.year(normalizedYear.year());
      this.date.setValue(ctrlValue);
    }
    else {
      this.date.patchValue(moment());
      ctrlValue = this.date.value;
      if (ctrlValue) {
        ctrlValue.year(normalizedYear.year());
        this.date.setValue(ctrlValue);
      }
    }

  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    let utc_date = formatDate(moment(this.date.value).toDate())
    this.form.get(this.controlName).setValue(utc_date);
    this.onChange.emit({ value: utc_date });
    console.log(this.form.get(this.controlName).value)
  }

}


